export default __webpack_public_path__ + "static/media/good-day-background-harbolnas.7f514dc3.png";